export default __webpack_public_path__ + "static/media/nithya.c1b7c348.jpg";